// dependencies
import { useQuery } from "@tanstack/react-query";

// queries
import { cohortQuery, cohortsQuery } from "../../queries";

// schema
/**
 * Returns a company's cohorts, by default only cohorts with 3 or more members are returned
 * @param showAll shows all cohorts including those with less than 3 members
 * @returns
 */
export const useCohorts = () => {
	return useQuery(cohortsQuery());
};

export const useCohort = (cohortID: string) => {
	return useQuery(cohortQuery(cohortID));
};
